import StorageService from "./StorageService";

const siteMetadata = {
    bot: {
        id: 'bot',
        title: 'CloudMocks',
        analyticsId: 'UA-37280276-5',
        tenantType: 'corebot',
        serviceDescription: 'bot'
    },
    mocks: {
        id: 'mocks',
        title: 'CloudMocks',
        analyticsId: 'UA-37280276-7',
        tenantType: 'imposter',
        serviceDescription: 'mock'
    }
};

const siteIdKey = 'site';

class SiteService {
    /**
     * @return {object} site metadata
     */
    getSite = () => {
        let siteId;
        const params = new URLSearchParams(window.location.search);
        if (params.has(siteIdKey)) {
            siteId = params.get(siteIdKey);
            StorageService.setSessionItem(siteIdKey, siteId);
        } else if (StorageService.hasSessionItem(siteIdKey)) {
            siteId = StorageService.getSessionItem(siteIdKey);
        } else {
            siteId = /gatehill.io/g.test(window.location.hostname) ? 'bot' : 'mocks';
        }
        return siteMetadata[siteId || 'mocks'];
    };

    /**
     * @return {boolean}
     */
    isBotSite = () => this.getSite().id === 'bot';

    /**
     * @return {boolean}
     */
    isMocksSite = () => this.getSite().id === 'mocks';

    /**
     * @return {string}
     */
    getSiteName = () => this.getSite().title;

    /**
     * @return {string} the analytics site ID
     */
    getAnalyticsSiteId = () => this.getSite().analyticsId;

    /**
     * @return {string} the service name
     */
    getTenantType = () => this.getSite().tenantType;

    /**
     * @return {string} the service description
     */
    describeService = () => this.getSite().serviceDescription
}

const siteService = new SiteService();
const currentSiteName = siteService.getSiteName();

export default siteService;
export {currentSiteName}



// WEBPACK FOOTER //
// ./src/modules/service/SiteService.js